import React from 'react';

import { placeHolderRatio16X9 } from 'src/styles/styles';

import * as customStyled from './styles';
const UpnextSkeletonLoader: React.FC = () => {
  return (
    <div css={customStyled.skeletonWrapper}>
      <div css={customStyled.skeletonCard}>
        <figure css={placeHolderRatio16X9}>
          <div css={customStyled.skeletonContent} />
        </figure>
      </div>
      <footer>
        <h4 css={customStyled.skeletonCardTitle}></h4>
        <div css={customStyled.skeletonCardTagWrapper}>
          <span css={customStyled.skeletonCardTag}></span>
          <span css={customStyled.skeletonCardTag}></span>
          <span css={customStyled.skeletonCardTag}></span>
        </div>
      </footer>
    </div>
  );
};

export default UpnextSkeletonLoader;
